export default {
  forbidden: { title: 'Acesso restrito', icon: 'fas fa-ban fa-4x text-error' },
  couponNotFound: { title: '404', icon: 'fas fa-ticket-alt fa-4x text-error' },
  planNotFound: { title: '404', icon: 'fas fa-shapes fa-4x text-error' },
  collectionNotFound: { title: '404', icon: 'fas fa-boxes fa-4x text-error' },
  recordNotFound: { title: '404', icon: 'fas fa-search fa-4x text-error' },
}
